module.exports = __webpack_public_path__ + "img/TechCavAttack1_ua.dd57e303.webp";